import React from "react";
import { useQuery } from "react-query";
import { connect, useDispatch } from "react-redux";
import { clearSubmitErrors, Field, formValueSelector, reduxForm, submit } from "redux-form";
import RideService from "../../../../services/ride";
import ProgressButton from "../../../../components/ProgressButton";
import { FormVehicleTypeField } from "../../../../components/fields";
import transformToRide from '../../../../utils/transformToRide';
import { FormFooter } from "../FormFooter";
import styles from "./style.module.css";

const getVehicleTypes = async (ride) => {
  return !ride ? await RideService.availability() : await RideService.ride(ride);
};

const VehicleTypes = React.memo(({ formData, minPax, handleSubmit, submitting }) => {
  const dispatch = useDispatch();
  const ride = React.useMemo(() => transformToRide(formData), [ formData ]);

  const { isFetching: vehicleTypeFetching, data: vehicleType = [] } = useQuery(
    [ "vehicleTypes", ride ],
    getVehicleTypes,
    {
      retry: false,
      refetchOnWindowFocus: false,
      queryFnParamsFilter: args => args.slice(1),
    });

  return (
    <form onSubmit={handleSubmit}>
      <Field name="vehicleType"
             component={FormVehicleTypeField}
             className={styles.vehicleTypeField}
             options={vehicleType}
             minPax={minPax}
             isFetching={vehicleTypeFetching}
      />
      <FormFooter>
        <ProgressButton
          type='submit'
          onClick={() => dispatch(submit("reservation"))}
          color="primary"
          variant='contained'
          disabled={submitting}
          isFetching={submitting}
          className={styles.button}
        >
          Payment
        </ProgressButton>
      </FormFooter>
    </form>
  );
});

const InitializeFromStateForm = reduxForm({
  form: "reservation",
  enableReinitialize: true,
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: true,
  forceUnregisterOnUnmount: true,
  onChange: (values, dispatch, props) => {
    if (props.error) dispatch(clearSubmitErrors("reservation"));
  },
})(VehicleTypes);

const selector = formValueSelector("reservation");

const mapStateToProps = (state) => {
  return {
    formData: selector(state, 'routePoints', 'pet', 'mask', 'package', 'dateTime', 'minPax', 'routePath', 'account'),
    minPax: selector(state, "minPax"),
  };
};

export default connect(mapStateToProps)(InitializeFromStateForm);
